import { createFeature, createReducer, on } from '@ngrx/store';
import * as actions from '../actions/color-legends';
import { TaskLegend } from 'app/models/api/color';

export interface ColorLegendsState {
  loading: boolean;
  palette: TaskLegend[];
}

export const initialState: ColorLegendsState = {
  loading: false,
  palette: []
};

export const usersFeature = createFeature({
  name: 'color-legends',
  reducer: createReducer(
    initialState,
    on(actions.loadPalette, state => ({ ...state, loading: true })),
    on(actions.loadPaletteFail, state => ({ ...state, loading: false })),
    on(actions.loadPaletteSuccess, (state, action) => ({ ...state, loading: false, palette: action.palette })),
  )
});

export const { name, reducer, selectPalette, selectLoading } = usersFeature;
